<template>
    <div class="modal ver2" id="winningList_popup" :class="{ show: props.show }">
        <div class="modal_box">
            <div class="modal_head inner">
                <div class="h_left"></div>
                <div class="h_title">{{ rank }}등 당첨번호</div>
                <div class="h_right">
                    <button type="button" class="btn clear_btn close_btn" @click="closeWinningModal"></button>
                </div>
            </div>
            <div class="modal_body inner">
                <div class="form_box">
                    <div class="input_box wid50">
                        <label for="mem_account" class="label_text">회차</label>
                        <input type="text" id="mem_account" class="input_text" :value="props.data.round" readonly>
                    </div>
                    <div class="input_box date wid50">
                        <label for="mem_account" class="label_text">추첨일</label>
                        <input type="text" id="mem_date" class="input_text datepicker" :value="props.data.draw_date"
                            disabled>
                    </div>
                    <div class="input_box date wid100">
                        <label class="label_text">추첨번호</label>
                        <div class="winning_box">
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_1 < 10, 'color2': props.data.num_1 >= 10 && props.data.num_1 < 20, 'color3': props.data.num_1 >= 20 && props.data.num_1 < 30, 'color4': props.data.num_1 >= 30 && props.data.num_1 < 40, 'color5': props.data.num_1 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_1 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_2 < 10, 'color2': props.data.num_2 >= 10 && props.data.num_2 < 20, 'color3': props.data.num_2 >= 20 && props.data.num_2 < 30, 'color4': props.data.num_2 >= 30 && props.data.num_2 < 40, 'color5': props.data.num_2 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_2 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_3 < 10, 'color2': props.data.num_3 >= 10 && props.data.num_3 < 20, 'color3': props.data.num_3 >= 20 && props.data.num_3 < 30, 'color4': props.data.num_3 >= 30 && props.data.num_3 < 40, 'color5': props.data.num_3 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_3 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_4 < 10, 'color2': props.data.num_4 >= 10 && props.data.num_4 < 20, 'color3': props.data.num_4 >= 20 && props.data.num_4 < 30, 'color4': props.data.num_4 >= 30 && props.data.num_4 < 40, 'color5': props.data.num_4 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_4 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_5 < 10, 'color2': props.data.num_5 >= 10 && props.data.num_5 < 20, 'color3': props.data.num_5 >= 20 && props.data.num_5 < 30, 'color4': props.data.num_5 >= 30 && props.data.num_5 < 40, 'color5': props.data.num_5 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_5 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.num_6 < 10, 'color2': props.data.num_6 >= 10 && props.data.num_6 < 20, 'color3': props.data.num_6 >= 20 && props.data.num_6 < 30, 'color4': props.data.num_6 >= 30 && props.data.num_6 < 40, 'color5': props.data.num_6 >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.num_6 }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="winning_plus"></div>
                            <div class="winning_item medium">
                                <div class="winning_ball"
                                    :class="{ 'color1': props.data.bonus_num < 10, 'color2': props.data.bonus_num >= 10 && props.data.bonus_num < 20, 'color3': props.data.bonus_num >= 20 && props.data.bonus_num < 30, 'color4': props.data.bonus_num >= 30 && props.data.bonus_num < 40, 'color5': props.data.bonus_num >= 40 }">
                                    <div class="numbox">
                                        <span class="num">{{ props.data.bonus_num }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tbl_wrap">
                    <div class="tbl_titbox">
                        <p class="tit">
                            당첨된 추출 내역 <span class="color">({{ winningList.length }})</span>
                        </p>
                    </div>
                    <br />
                    <DataTable ref="table" :data="winningList" class="tbl" :columns="columns" :options="dtOptions">
                    </DataTable>

                </div>
            </div>
            <div class="modal_pagination">
                <!-- <button type="button" class="page_btn prev_btn">
                    <img src="img/page_prev2.png" alt="" class="icon">
                    <span class="txt">이전 보기</span>
                </button>
                <button type="button" class="page_btn next_btn">
                    <span class="txt">다음 보기</span>
                    <img src="img/page_next2.png" alt="" class="icon">
                </button> -->
            </div>
        </div>
    </div>
</template>
<script setup>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
DataTable.use(DataTablesCore);
import { defineProps, defineEmits, onMounted, ref } from "vue";
import { getWinningListByRoundAndRank } from "@/api";
const emit = defineEmits(['closeWinningModal']);
const winningList = ref([]);

const closeWinningModal = () => {
    emit('closeWinningModal');
}

const columns = [
    {
        data: 'draw_date', title: '추출일', render: (data) => {
            const date = new Date(data);
            return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`
        },
        className: 'date'
    },
    {
        data: 'num_1', title: '추출번호', render: (data, type, row) => {
            return `<div class="winning_box">
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_1 < 10 ? 'color1' : row.num_1 >= 10 && row.num_1 < 20 ? 'color2' : row.num_1 >= 20 && row.num_1 < 30 ? 'color3' : row.num_1 >= 30 && row.num_1 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_1}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_2 < 10 ? 'color1' : row.num_2 >= 10 && row.num_2 < 20 ? 'color2' : row.num_2 >= 20 && row.num_2 < 30 ? 'color3' : row.num_2 >= 30 && row.num_2 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_2}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_3 < 10 ? 'color1' : row.num_3 >= 10 && row.num_3 < 20 ? 'color2' : row.num_3 >= 20 && row.num_3 < 30 ? 'color3' : row.num_3 >= 30 && row.num_3 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_3}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_4 < 10 ? 'color1' : row.num_4 >= 10 && row.num_4 < 20 ? 'color2' : row.num_4 >= 20 && row.num_4 < 30 ? 'color3' : row.num_4 >= 30 && row.num_4 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_4}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_5 < 10 ? 'color1' : row.num_5 >= 10 && row.num_5 < 20 ? 'color2' : row.num_5 >= 20 && row.num_5 < 30 ? 'color3' : row.num_5 >= 30 && row.num_5 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_5}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="winning_item small">
                                        <div class="winning_ball ${row.num_6 < 10 ? 'color1' : row.num_6 >= 10 && row.num_6 < 20 ? 'color2' : row.num_6 >= 20 && row.num_6 < 30 ? 'color3' : row.num_6 >= 30 && row.num_6 < 40 ? 'color4' : 'color5'}">
                                            <div class="numbox">
                                                <span class="num">${row.num_6}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>`
        },
        className: 'winning'
    },
    {
        data: 'email', title: '계정', render: (data) => {
            return data;
        }
    },

]

onMounted(async () => {
    const res = await getWinningListByRoundAndRank(props.data.round, props.rank);
    if (res.status === 200) {
        winningList.value = res.data.list;
        console.log(winningList.value);
    }
})

const dtOptions = {
    paging: true,  // 페이지네이션 활성화
    searching: false,  // 검색 활성화
    info: false,
    pageLength: 10,
    lengthChange: false,
    language: {
        emptyTable: '데이터가 없습니다.', // 메시지 변경
    },
}
const props = defineProps({
    show: Boolean,
    data: Object,
    rank: Number
});

</script>
<style scoped>
.form_box {
    flex-direction: unset !important;
}

:deep(.dt-paging-button) {
    width: 40px;
    height: 40px;
    font-size: 14px;
    line-height: 157%;
    letter-spacing: -0.04em;
    color: var(--color-text);
    border: 1px solid var(--color-border2);
    border-radius: 8px;
    background: var(--color-white);
    overflow: hidden;
    margin: 0 10px;
}

:deep(.dt-paging-button.current) {
    font-weight: 700;
    color: var(--color-white);
    background: var(--color-gradient1);
}

:deep(.dt-paging nav) {
    display: flex;
    justify-content: center;
}

:deep(.dt-paging) {
    margin-top: 20px;
    margin-bottom: 20px;
}

:deep(.dt-search) {
    display: none
}
</style>